export default "__VITE_ASSET__CSmus3jg__"